(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[461],{

/***/ 53829:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/register",
      function () {
        return __webpack_require__(98155);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/chunk-UQDW7KKV.mjs
var chunk_UQDW7KKV = __webpack_require__(45161);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-5MKCW436.mjs
var chunk_5MKCW436 = __webpack_require__(22338);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-ZHMYA64R.mjs + 2 modules
var chunk_ZHMYA64R = __webpack_require__(55281);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-7OLJDQMT.mjs
var chunk_7OLJDQMT = __webpack_require__(22757);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chunk-KC77MHL3.mjs + 3 modules
var chunk_KC77MHL3 = __webpack_require__(83558);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-3ASUQ6PA.mjs
var chunk_3ASUQ6PA = __webpack_require__(34292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs
var chunk_2OOHT3W5 = __webpack_require__(71293);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-UVUR7MCU.mjs + 3 modules
var chunk_UVUR7MCU = __webpack_require__(93108);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-PULVB27S.mjs
var chunk_PULVB27S = __webpack_require__(57747);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-W7WUSNWJ.mjs
var chunk_W7WUSNWJ = __webpack_require__(49289);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./components/auth/OAuthButtonGroup.jsx + 2 modules
var OAuthButtonGroup = __webpack_require__(19422);
// EXTERNAL MODULE: ./components/layouts/navbar/DarkLogo.jsx
var DarkLogo = __webpack_require__(24498);
// EXTERNAL MODULE: ./components/layouts/navbar/LightLogo.jsx
var LightLogo = __webpack_require__(30309);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/utils/AffiliateInitScript.jsx



var AffiliateInitScript = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            id: "affiliate-init",
            dangerouslySetInnerHTML: {
                __html: '\n              (function(w, d, s, p, t) { w.gr = w.gr || function() { w.gr.q = w.gr.q || []; w.gr.q.push(arguments); }; p = d.getElementsByTagName(s)[0]; t = d.createElement(s); t.async = true; t.src = "https://app.getreditus.com/gr.js?_ce=90"; p.parentNode.insertBefore(t, p); })(window, document, "script"); gr("track", "pageview");\n            '
            }
        })
    });
};
/* harmony default export */ var utils_AffiliateInitScript = (AffiliateInitScript);

// EXTERNAL MODULE: ./components/utils/const.js
var utils_const = __webpack_require__(61502);
// EXTERNAL MODULE: ./components/utils/FormikControl.jsx + 7 modules
var FormikControl = __webpack_require__(49063);
// EXTERNAL MODULE: ./lib/common.js
var common = __webpack_require__(15021);
;// CONCATENATED MODULE: ./pages/auth/register.js



















var RegisterPage = function() {
    var currentLocale = esm/* i18n.language */.ag.language === "en" ? "" : "/" + esm/* i18n.language */.ag.language;
    //translation i18next
    var t = (0,esm/* useTranslation */.$G)([
        "auth",
        "common",
        "validation"
    ]).t;
    var invalidEmailText = t("validation:email.invalid");
    var requiredText = t("validation:required-field");
    var termsConditionsText = t("validation:terms-conditions");
    var createText = t("auth:register.create-account");
    var haveAccountText = t("auth:register.have-an-account");
    var logInText = t("common:log-in");
    var signUpText = t("auth:sign-up");
    var passwordInvalidText = t("validation:password-or-email-invalid");
    var signInWithText = t("auth:sign-with");
    var acceptText = t("auth:register.accept");
    var passwordText = t("common:password");
    var emailText = t("common:email");
    var fullNameText = t("common:full-name");
    var registerLinkText = t("auth:register.link-text");
    var logo = (0,chunk_UQDW7KKV/* useColorModeValue */.ff)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DarkLogo/* DarkLogo */.w, {}), /*#__PURE__*/ (0,jsx_runtime.jsx)(LightLogo/* LightLogo */._, {}));
    var ref = (0,node_modules_react.useState)(false), errorCredentialsSignin = ref[0], setErrorCredentialsSignin = ref[1];
    var handleSignIn = function() {
        router_default().push("".concat(currentLocale, "/auth/login"));
        return;
    };
    var fetcher = (0,dist/* useSWRConfig */.kY)().fetcher;
    var initialValues = {
        email: "",
        password: "",
        name: "",
        termsOfService: false
    };
    var validationSchema = es.object({
        email: es.string().email(invalidEmailText).required(requiredText),
        password: es.string().min(6).required(requiredText),
        name: es.string().required(requiredText),
        termsOfService: es.boolean().required(termsConditionsText).oneOf([
            true
        ], termsConditionsText)
    });
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, props) {
            var res, accessToken, fields, key;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetcher === null || fetcher === void 0 ? void 0 : fetcher("/accounts/register/", {
                            email: values.email,
                            first_name: values.name,
                            password: values.password
                        }, utils_const/* HTTP_POST */.qg);
                    case 2:
                        res = _ctx.sent;
                        if (!(res === null || res === void 0 ? void 0 : res.id)) {
                            _ctx.next = 15;
                            break;
                        }
                        if (!(0,common/* checkCookie */.pE)("_gr_id")) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 7;
                        return axios_default().post("".concat("https://api.migrationpro.io/v2", "/accounts/token/"), {
                            email: res.email,
                            password: values.password
                        }).then(function(res) {
                            var ref;
                            if (res.data) return (ref = res.data) === null || ref === void 0 ? void 0 : ref.access_token;
                        });
                    case 7:
                        accessToken = _ctx.sent;
                        if (!accessToken) {
                            _ctx.next = 12;
                            break;
                        }
                        //send request to reditus
                        window.gr("track", "conversion", {
                            email: res.email
                        });
                        _ctx.next = 12;
                        return axios_default().post("".concat("https://api.migrationpro.io/v2", "/marketing/lead/"), {
                            affiliate: "getreditus"
                        }, {
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        });
                    case 12:
                        (0,react.signIn)("credentials", {
                            email: res.email,
                            password: values.password
                        });
                        _ctx.next = 16;
                        break;
                    case 15:
                        {
                            if (res.status === 400) {
                                if (res === null || res === void 0 ? void 0 : res.data) {
                                    fields = res.data;
                                    for(key in fields){
                                        props.setFieldError(key, "".concat(fields[key]));
                                    }
                                }
                            } else if (res.status === 401) {
                            //TODO: Raise error to Sentry
                            }
                        }
                    case 16:
                        props.setSubmitting(false);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values, props) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_AffiliateInitScript, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_5MKCW436/* Container */.W, {
                maxW: "xl",
                py: {
                    base: "12",
                    md: "24"
                },
                px: {
                    base: "0",
                    sm: "8"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
                    spacing: "8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
                            spacing: "6",
                            children: [
                                logo,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
                                    spacing: {
                                        base: "2",
                                        md: "3"
                                    },
                                    textAlign: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
                                            size: (0,chunk_KC77MHL3/* useBreakpointValue */.S)({
                                                base: "xs",
                                                md: "sm"
                                            }),
                                            children: createText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_3ASUQ6PA/* HStack */.U, {
                                            spacing: "1",
                                            justify: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                                                    color: "muted",
                                                    children: haveAccountText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_UVUR7MCU/* Button */.z, {
                                                    variant: "link",
                                                    colorScheme: "blue",
                                                    onClick: handleSignIn,
                                                    children: logInText
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_PULVB27S/* Box */.xu, {
                            py: {
                                base: "0",
                                sm: "8"
                            },
                            px: {
                                base: "4",
                                sm: "10"
                            },
                            bg: (0,chunk_KC77MHL3/* useBreakpointValue */.S)({
                                base: "transparent",
                                sm: "bg-surface"
                            }),
                            boxShadow: {
                                base: "none",
                                sm: (0,chunk_UQDW7KKV/* useColorModeValue */.ff)("md", "md-dark")
                            },
                            borderRadius: {
                                base: "none",
                                sm: "xl"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                initialValues: initialValues,
                                validationSchema: validationSchema,
                                onSubmit: onSubmit,
                                children: function(formik) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
                                            spacing: "6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
                                                    spacing: "5",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikControl/* default */.Z, {
                                                            control: "input",
                                                            type: "text",
                                                            label: fullNameText,
                                                            name: "name"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikControl/* default */.Z, {
                                                            control: "input",
                                                            type: "email",
                                                            label: emailText,
                                                            name: "email"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikControl/* default */.Z, {
                                                            control: "password",
                                                            label: passwordText,
                                                            name: "password"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_ZHMYA64R/* Stack */.K, {
                                                    justify: "center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikControl/* default */.Z, {
                                                        control: "checkbox",
                                                        name: "termsOfService",
                                                        text: acceptText,
                                                        linkText: registerLinkText,
                                                        link: "https://migrationpro.io/pages/terms-of-service"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
                                                    spacing: "6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_UVUR7MCU/* Button */.z, {
                                                            // variant="primary"
                                                            mt: 4,
                                                            colorScheme: "blue",
                                                            isLoading: formik.isSubmitting,
                                                            disabled: !formik.isValid,
                                                            type: "submit",
                                                            children: signUpText
                                                        }),
                                                        errorCredentialsSignin && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                                                            fontSize: "sm",
                                                            color: "red.300",
                                                            textAlign: "center",
                                                            children: passwordInvalidText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_3ASUQ6PA/* HStack */.U, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_W7WUSNWJ/* Divider */.i, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                                                                    fontSize: "sm",
                                                                    whiteSpace: "nowrap",
                                                                    color: "muted",
                                                                    children: signInWithText
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_W7WUSNWJ/* Divider */.i, {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OAuthButtonGroup/* OAuthButtonGroup */.g, {})
                                                    ]
                                                })
                                            ]
                                        })
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var register = (RegisterPage);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6556,4450,86,8424,4444,6248,5282,3998,9774,2888,179], function() { return __webpack_exec__(53829); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);